import { ValueOf } from '@@types/common';

export const EDITOR_ORIGIN = {
  // hint
  MENTION_COMPLETE: 'mentionComplete',
  EMOJI_COMPLETE: 'emojiComplete',
  COMMAND_COMPLETE: 'commandComplete',
  COMMAND_MENTION_COMPLETE: 'commandMentionComplete',
  COMMAND_CHANNEL_MENTION_COMPLETE: 'commandChannelMentionComplete',

  // action
  PASTE_COMPLETE: 'pasteComplete',
  COMMAND_TRIGGER_COMPLETE: 'commandTriggerComplete',
  MENTION_TRIGGER_COMPLETE: 'mentionTriggerComplete',
  INLINE_CODE_BLOCK_COMPLETE: 'inlineCodeBlockComplete',
  CODE_BLOCK_COMPLETE: 'codeBlockComplete',

  // native
  SET_VALUE: 'setValue',
  UNDO: 'undo',
  REDO: 'redo',
};
export type EDITOR_ORIGIN = ValueOf<typeof EDITOR_ORIGIN>;
